import { dayKeyOf, formatClock, formatDayChip } from "./agenda-schedule";
import type { NextSession } from "./now-model";

/**
 * A slim "Next" row under the live card: the next session's start, its title
 * and its room. The day shows under the time when it is not the day of `at`.
 */
export function NowNextRow({
  next,
  at,
  timeZone,
}: {
  next: NextSession;
  at: Date;
  timeZone: string;
}) {
  const day = dayKeyOf(next.start, timeZone);
  const sameDay = day === dayKeyOf(at, timeZone);
  const place = [
    next.room,
    next.more > 0 ? `${next.more} more at this time` : "",
  ]
    .filter(Boolean)
    .join(" · ");

  return (
    <div
      className="flex min-w-0 items-center gap-4 rounded-xl border border-border bg-card px-4 py-3.5"
      data-testid="now-next-row"
    >
      <div className="flex min-w-16 shrink-0 flex-col gap-0.5 whitespace-nowrap">
        <span className="text-xs font-semibold uppercase tracking-[0.1em] text-muted-foreground">
          Next
        </span>
        <span className="text-[1.375rem] font-bold leading-none tabular-nums text-foreground">
          {formatClock(next.start, timeZone)}
        </span>
        {!sameDay && (
          <span className="text-xs text-muted-foreground">
            {formatDayChip(day)}
          </span>
        )}
      </div>
      <div className="flex min-w-0 flex-col gap-0.5">
        <span className="font-display text-[1.375rem] leading-tight text-foreground wrap-anywhere">
          {next.item.title}
        </span>
        {place && (
          <span className="text-sm text-muted-foreground wrap-anywhere">
            {place}
          </span>
        )}
      </div>
    </div>
  );
}
